import { cn } from '../../lib/utils';

export type DividerProps = {
  orientation?: 'horizontal' | 'vertical';
  /**
   * When true, the divider is purely visual (`role="presentation"`).
   * Set false if the rule separates named sections for assistive tech.
   */
  decorative?: boolean;
  className?: string;
};

export function Divider({
  orientation = 'horizontal',
  decorative = true,
  className,
}: DividerProps) {
  if (orientation === 'vertical') {
    return (
      <div
        role={decorative ? 'presentation' : 'separator'}
        aria-orientation={decorative ? undefined : 'vertical'}
        aria-hidden={decorative ? true : undefined}
        className={cn('w-px shrink-0 self-stretch bg-border', className)}
      />
    );
  }

  return (
    <hr
      role={decorative ? 'presentation' : 'separator'}
      aria-orientation={decorative ? undefined : 'horizontal'}
      aria-hidden={decorative ? true : undefined}
      className={cn('w-full border-0 border-t border-border', className)}
    />
  );
}
